import { Typography, CategoryHeading, Heading, Link } from "zudoku/components";
import { UnlinkIcon } from "lucide-react";

export const NotFoundPage = () => (
    <Typography
        className="h-full pt-(--padding-content-top) mx-auto w-full max-w-5xl"
        data-pagefind-ignore="all"
    >
        <CategoryHeading>404</CategoryHeading>
        <Heading level={1} className="flex gap-3.5 items-center">
            Page not found
            <UnlinkIcon size={24} />
        </Heading>
        <p>
            The page you are looking for does not exist or may have
            been moved. Please check the URL for any typos or use the navigation
            menu to find the correct page.
        </p>
        <Link to="/">Go back home</Link>
    </Typography>
);
